import React from 'react'
import {Link} from 'react-router-dom'

const Dashboard = () => {
  const stats = [
    {id: '000-1', title: 'Pending Signatures', value: 12, path: '/pending-requests'},
    {id: '000-2', title: 'Completed', value: 104, path: ''},
    {id: '000-3', title: 'Rejected / Expired', value: 12, path: '/pending-requests'},
    {id: '000-4', title: 'Total Documents', value: 128, path: ''},
  ]

  return (
    <div className='row mb-4'>
      {stats.map((item) => (
        <Link to={item.path} key={item.id} className='col-md-3 mb-3'>
          <div className='card py-10'>
            <div className='text-center'>
              <h6 className='text-muted'>{item.title}</h6>
              <h2 className='fw-bold'>{item.value}</h2>
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default Dashboard
